import { ref, markRaw, type Component } from "vue";

interface PanelConfig {
  title?: string;
  subtitle?: string;
}

export const currentPanel = ref<{
  component: Component;
  props?: Record<string, unknown>;
  config: PanelConfig & { closing?: boolean };
} | null>(null);

export const usePanel = () => {
  function showPanel(
    component: Component,
    props?: Record<string, unknown>,
    config: PanelConfig = {},
  ) {
    currentPanel.value = {
      component: markRaw(component),
      props,
      config: { ...config, closing: false },
    };
  }

  function closePanel() {
    if (!currentPanel.value) return;

    currentPanel.value.config.closing = true;

    setTimeout(() => {
      currentPanel.value = null;
    }, 300);
  }

  return { currentPanel, showPanel, closePanel };
};
